import { EFilterActionTypes } from 'shared/actions/filter/actions';
import { type IFilter } from 'shared/types/filter';
import { type TReduxActions } from 'shared/types/redux';

import { defaultFilterInitialState } from './defaultFilterInitialState';

export function filterReducer(state: IFilter = defaultFilterInitialState, action: TReduxActions): IFilter {
  switch (action.type) {
    case EFilterActionTypes.RegionChange:
      return { ...state, location: action.payload };
    case EFilterActionTypes.RoomsChange:
      return { ...state, rooms: action.payload };
    case EFilterActionTypes.MinPriceChange:
      return { ...state, minPrice: action.payload };
    case EFilterActionTypes.MaxPriceChange:
      return { ...state, maxPrice: action.payload };
    case EFilterActionTypes.MinAreaChange:
      return { ...state, minArea: action.payload };
    case EFilterActionTypes.MaxAreaChange:
      return { ...state, maxArea: action.payload };
    case EFilterActionTypes.DeadlineChange:
      return { ...state, deadline: action.payload };
    case EFilterActionTypes.DeadlineVariantsChange:
      return { ...state, deadlineVariants: action.payload };
    case EFilterActionTypes.ReadyApartmentChange:
      return { ...state, readyApartments: action.payload };
    case EFilterActionTypes.ApartmentWithDecorationChange:
      return { ...state, apartmentsWithDecoration: action.payload };

    default:
      return state;
  }
}
